// extracted by mini-css-extract-plugin
export default {"zineListContainer":"ZineList_zineListContainer__AE+5y"};